import React from "react";
import {
  Box,
  Card,
  Container,
  Grid,
  Stack,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import Helmet from "helmet";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  // backgroundColor: theme.palette.grey[100],
  backgroundImage: `url('/images/Generated Image September 10, 2025 - 3_05PM.png')`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  maxHeight: "auto",
  height: `100vh`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const ContentStyle = styled("div")(({ theme, maxWidth }) => ({
  maxWidth: "100vw",
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

// ----------------------------------------------------------------------

const AuthPage = ({ title, children, maxWidth = 600 }) => {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <RootStyle>
        <ContentStyle maxWidth={maxWidth}>
          <Box
            // elevation={2}
            sx={{
              mx: "auto",
              // display: "flex",
              // justifyContent: "center",
              width: { sm: "80%", md: "80%" },
              backgroundColor: "#fff",
              // height: "100%",
              borderRadius: 3,
            }}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                sm={5}
                // md={4}
                sx={{
                  p: 4,
                  display: { xs: "none", sm: "flex" },
                  flexDirection: "column",
                  justifyContent: "center",
                  backgroundColor: theme.palette.grey[50],
                  backgroundImage: `url('/images/Generated Image September 15, 2025 - 10_27AM.png')`,
                  backgroundSize: "cover",
                  backgroundPosition: "right",
                  backgroundRepeat: "no-repeat",
                  backgroundOrigin: "border-box",
                  borderRadius: 3,
                }}
              >
                <Stack sx={{ textAlign: "left" }}>
                  <Box
                    sx={{
                      maxWidth: { sm: "40%", md: "30%" },
                      display: { xs: "none", sm: "block" },
                    }}
                  >
                    <img
                      src={"/images/logo/dSacco.png"}
                      alt="logo"
                      style={{ width: "100%", marginBottom: theme.spacing(3) }}
                    />
                  </Box>

                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      fontSize: { xs: "1.2rem", sm: "1.5rem" },
                      color: theme.palette.primary.main,
                    }}
                  >
                    Welcome to the Digital SACCO
                  </Typography>

                  <Typography variant="body1" color="text.secondary">
                    Empowering your financial journey, one step at a time.
                  </Typography>
                </Stack>
              </Grid>

              <Grid
                item
                xs={12}
                sm={7}
                // md={8}
                sx={{
                  p: { xs: 3, sm: 6 },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignContent: "center",
                }}
              >
                <Box
                  sx={{
                    maxWidth: "30%",
                    display: { xs: "flex", sm: "none" },
                    alignSelf: "center",
                  }}
                >
                  <img
                    src={"/images/logo/dSacco.png"}
                    alt="logo"
                    style={{
                      width: "100%",
                    }}
                  />
                </Box>
                {children}
              </Grid>
            </Grid>
          </Box>
        </ContentStyle>
      </RootStyle>
    </>
  );
};

export default AuthPage;
